module.exports = __webpack_public_path__ + "static/millennium-falcon-97eeda8eebd56b2b095c552cbdb0da1b.svg";